(ns manage.product-page.view
  (:require ["@mui/material/Fade$default" :as Fade]
            [common.modal.dialog :refer [deletion-confirmation]]
            [common.modal.view :refer [defmodal]]
            [common.queries :refer [use-mutation]]
            [common.resource.query.product :as product-queries]
            [common.widgets.page :as page]
            [linked.core :as l]
            [manage.feed-table.view :as feed-table]
            [manage.product-selector-page.view :refer [product-selector-page]]
            [manage.product-selector-table.view :as product-selector-table]
            [manage.product-store-form.view :as product-store-form]
            [manage.product-table.view :as product-table]
            [manage.script-table.view :as script-table]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui] :as uix]
            [uix.re-frame :refer [use-subscribe]]))

(defui scripts []
  ($ script-table/scripts-data-grid))

(defui configure-store []
  ($ product-store-form/blocks))

(defui products []
  (let [allowed-to-edit-products? (use-subscribe [:resource.user/allowed? "products.edit"])]
    ($ product-table/products-datagrid
       {:on-row-click #(rf/dispatch [:ocp/open {:id :product/crud
                                                :props {:product %}}])
        :show-create-and-delete? allowed-to-edit-products?})))

(defui feed-importers []
  ($ feed-table/table {:feed-type :product}))

(def products-tabs
  ;; The page already requires products.view permission,
  ;; no need to add that to the tabs.
  (l/map :products
         {:label "Inventory"
          :view products
          :container-sx #js {:overflow "hidden"}}

         :product-selector
         {:label "Selectors"
          :view product-selector-table/product-selector-table
          :container-sx #js {:overflow "hidden"}}

         :scripts
         {:label "Scripts"
          :permission "products.configure"
          :view scripts}

         :configure-store
         {:label "Store configuration"
          :permission "products.configure"
          :view configure-store}

         :feed-importers
         {:label "Importers"
          :view feed-importers
          :container-sx #js {:overflow "hidden"}}))

(defn products-page []
  (let [view (use-subscribe [:router/handler-name])
        product-selector-crud (= :advertiser/product-selector view)]
    (uix/use-effect (fn []
                      (rf/dispatch [:table.feed/init-table-with-type :product]))
                    [])
    ($ :<>
       ($ page/page
          ($ page/page-header
             {:title "Products"
              :tabs products-tabs})
          ($ page/active-tab
             {:tabs products-tabs}))

       ($ Fade
          {:in (boolean product-selector-crud)
           :unmountOnExit true}
          ($ product-selector-page)))))

(defmodal delete-all-products :delete-products-modal
  [_]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {delete-all :mutate} (use-mutation (product-queries/delete-all-products-mutation {:advertiser-id advertiser-id}))]
    [deletion-confirmation
     {:on-submit delete-all
      :entity-name "all products"
      :confirmation-message "You are about to delete all products. This means you'll lose all product data for this advertiser"}]))
